import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full flex items-center justify-center p-5 text-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text-md text-gray-600"
}

import { useI18n } from "vue-i18n";
import { useLogoUrl } from "@/composables/project";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerLogoWidget',
  emits: ["trackInteraction"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n();
const { logoUrl, isLogoUrlFetching } = useLogoUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: _unref(isLogoUrlFetching),
    onTrackInteraction: _cache[0] || (_cache[0] = ($event: any) => (emit('trackInteraction')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(logoUrl))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(logoUrl),
              class: "w-full h-full object-contain",
              alt: "logo"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("admin.general_project_settings.no_logo_available")), 1))
      ])
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})